// src/app/components/JsonLd.tsx

interface JsonLdProps {
  json: Record<string, unknown> | Array<Record<string, unknown>>;
}

export default function JsonLd({ json }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  );
}